import React from 'react';
import { useReframe } from 'nike-re-framejs';

import UnverifiedIcon from 'nike-ui/src/icons/svg/unverified-icon-sv.svg';
import i18n from '@i18n';
import { Button } from 'nike-ui/src/components/button/Button';
import { uploadDocumentsAction } from '@/menu/views/MainMenu';
import UserAnnouncement from '@/menu/views/UserAnnouncement';
import VerifyingIcon from 'nike-ui/src/icons/svg/verifying-icon-sv.svg';
import { accountForcedActions$, accountForcedActionStatus$ } from '@/account/subs';
import { FORCED_ACTIONS_STATE, getForcedActionsState } from 'nike-ui/src/components/registration-completion/util/utils';
import { FORCED_ACTION_STATUS } from 'nike-ui/src/components/registration-completion/view/step_forced_action_status/StepForcedActionStatus';

function UserAnnouncementStateRegistration({ state }) {
    return (
        <UserAnnouncement
            icon={UnverifiedIcon}
            title={i18n('account.dokoncenieRegistracie.title')}
            description={i18n('account.dokoncenieRegistracie.subtext.' + state)}
        >
            <Button
                className="red"
                onClick={uploadDocumentsAction}
                label={i18n('account.dokoncenieRegistracie')}
                primary
            />
        </UserAnnouncement>
    );
}

function OnbFinishRegistration() {
    const { derefSub, subscribe } = useReframe();
    const forcedActions = derefSub(accountForcedActions$) || [];
    const forcedActionStatus = subscribe(accountForcedActionStatus$);

    if (forcedActionStatus === FORCED_ACTION_STATUS.SLOT2REQUESTED) {
        return <UserAnnouncementStateRegistration state={forcedActionStatus} />;
    }

    const state = getForcedActionsState(forcedActions);
    switch (state) {
        case FORCED_ACTIONS_STATE.REQUIRED:
        case FORCED_ACTIONS_STATE.REQUIRED_OTHERS:
        case FORCED_ACTIONS_STATE.REQUIRED_IDENTITY_CHECK:
            return <UserAnnouncementStateRegistration state={state} />;
        case FORCED_ACTIONS_STATE.APPROVING:
            return (
                <UserAnnouncement
                    icon={VerifyingIcon}
                    title={i18n('account.overovanieRegistracie.title')}
                    description={i18n('account.overovaneKonto')}
                />
            );
        default:
            return null;
    }
}

export default OnbFinishRegistration;
